var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85528 2.53848C10.0416 2.46084 10.2563 2.50285 10.3997 2.64497L15.352 7.55569C15.4467 7.64958 15.5 7.7774 15.5 7.91074C15.5 8.04408 15.4467 8.1719 15.352 8.26578L10.3997 13.1765C10.2563 13.3186 10.0416 13.3606 9.85528 13.283C9.66897 13.2053 9.5476 13.0233 9.5476 12.8215V10.4946C8.96425 10.4797 7.91066 10.4852 6.68917 10.6511C4.8954 10.8949 2.81565 11.4753 1.32912 12.7752C1.1598 12.9233 0.912452 12.9401 0.72469 12.8162C0.536928 12.6924 0.454967 12.4584 0.524405 12.2445C1.21521 10.1161 2.90074 8.55955 4.70809 7.45861C6.36466 6.44953 8.17181 5.79315 9.5476 5.41496V3.00001C9.5476 2.79817 9.66897 2.61612 9.85528 2.53848ZM10.5476 4.19995V5.80001C10.5476 6.02889 10.3922 6.22855 10.1703 6.28472C8.82234 6.62597 6.9303 7.2759 5.22832 8.31264C4.07459 9.01543 3.03435 9.87964 2.30008 10.9237C3.69308 10.2007 5.23526 9.83949 6.55454 9.66025C8.33255 9.41867 9.7747 9.4991 10.0378 9.51377C10.0527 9.51461 10.0639 9.51523 10.0711 9.51557C10.3378 9.5281 10.5476 9.748 10.5476 10.015V11.6215L14.2899 7.91074L10.5476 4.19995Z",
    fill: "#22264C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShare);
export default __webpack_public_path__ + "static/media/ic_share.0e2e5f5d.svg";
export { ForwardRef as ReactComponent };